// extracted by mini-css-extract-plugin
export default {"userPicture":"UserDropdown_userPicture__L4WR5","menuAlignment":"UserDropdown_menuAlignment__50uUV"};